<template>
  <div class="seat-map-header d-none d-lg-block d-xl-block">
    <passenger-context-display
      v-if="isEditing"
      :passenger="currentPassenger"
      :is-holding-infant="isPassengerHoldingInfant"
    />
    <selection-instructions v-else />
  </div>
</template>

<script>
import PassengerContextDisplay from './passenger-context-display.vue'
import SelectionInstructions from '../messages/selection-instructions.vue'

export default {
  name: 'SeatMapHeader',
  components: {
    PassengerContextDisplay,
    SelectionInstructions,
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    currentPassenger: Object,
    isPassengerHoldingInfant: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
